import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { c as l } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import './Spinner.css';const e = "_small_1fp3w_1", m = "_medium_1fp3w_5", o = "_large_1fp3w_9", _ = "_spinner_1fp3w_13", v = "_light_1fp3w_86", p = "_dark_1fp3w_89", s = {
  small: e,
  medium: m,
  large: o,
  spinner: _,
  light: v,
  dark: p
}, c = l(s.spinner, {
  variants: {
    size: {
      s: s.small,
      m: s.medium,
      l: s.large
    },
    variant: {
      light: s.light,
      dark: s.dark
    }
  },
  defaultVariants: {
    size: "m",
    variant: "light"
  }
}), u = ({ className: a, size: r, variant: n }) => /* @__PURE__ */ t("div", { "aria-label": "loading", className: d(c({ size: r, variant: n }), a), role: "status", children: [
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {}),
  /* @__PURE__ */ i("div", {})
] });
export {
  u as S
};
